module.exports = __webpack_public_path__ + "img/hotel-mercure-lisboa.43d2eae1.jpg";